const token = {
  // 全局的state对象，用于保存所有组件公共数据
  // 此处如果有缓存则直接使用缓存的信息
  state: {
    token: {
      token: ''
    }
  },

  // 监听state对象值的最新状态（计算属性）
  getters: {
    getToken (state) {
      return state.token
    }
  },

  // 唯一一个可以修改state值的方法
  mutations: {
    updateToken (state, token) {
      state.token = token
    }
  },

  // 异步执行mutations方法
  actions: {
    asyncUpdateToken (context, token) {
      context.commit('updateToken', token)
    }
  }
}

export default token



// WEBPACK FOOTER //
// ./src/store/modules/token.js